/* eslint-disable spire/fenced-imports */

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { CheckoutReviewAndSubmitPageContext } from "@insite/content-library/Pages/CheckoutReviewAndSubmitPage";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import setReleaseNumber from "@tKgpco/Store/Data/CheckoutReviewAndSubmit/Handlers/ReleaseNumberHandler";
import { TYPOGRAPHY } from "@tKgpco/theme/design";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: CustomApplicationState) => {
    const cartState: any = getCurrentCartState(state).value;
    return {
        cartState,
        releaseNumber: state.KGPState.CheckoutReview.releaseNumber,
        isAwaitingApproval: cartState?.isAwaitingApproval,
    };
};

const mapDispatchToProps = {
    setReleaseNumber,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CheckoutShippingCarrierServiceStyles {
    releaseNumberGrid?: GridItemProps;
}

export const checkoutShippingCarrierServiceStyles: CheckoutShippingCarrierServiceStyles = {
    releaseNumberGrid: {
        width: 12,
        css: css`
            padding: 0px 5px 20px 16px;
            label {
                font-size: ${TYPOGRAPHY.size.smallest};
            }
        `,
    },
};

/**
 * @deprecated Use checkoutShippingCarrierServiceStyles instead.
 */
export const checkoutShippingCarrierService = checkoutShippingCarrierServiceStyles;
const styles = checkoutShippingCarrierServiceStyles;

const ReleaseNumber: FC<Props> = ({ setReleaseNumber, cartState, releaseNumber, isAwaitingApproval }) => {
    const [releaseNoValue, setReleaseNoValue] = useState(cartState?.properties?.releaseNumber || releaseNumber || "");
    useEffect(() => {
        setReleaseNumber({ releaseNumber: releaseNoValue });
    }, [releaseNoValue]);

    useEffect(() => {
        if (cartState?.properties && cartState.properties?.releaseNumber) {
            setReleaseNoValue(cartState?.properties?.releaseNumber);
            // setReleaseNumber(cartState.properties.releaseNumber.split("|")[1]);
        }
    }, [cartState?.properties]);

    return (
        <GridContainer>
            {/* Custom Release Number -- start */}
            <GridItem {...styles.releaseNumberGrid}>
                <TextField
                    label={translate("Release Number#")}
                    value={releaseNoValue}
                    onChange={e => {
                        setReleaseNoValue(e.currentTarget.value);
                    }}
                    disabled={isAwaitingApproval}
                />
            </GridItem>

            {/* Custom Release Number -- End */}
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ReleaseNumber),
    definition: {
        displayName: "Release Number",
        group: "Checkout - Review & Submit",
        allowedContexts: [CheckoutReviewAndSubmitPageContext],
    },
};

export default widgetModule;
